<template>
    <div
        v-if="bannerVisible"
        class="flex w-full items-center justify-center gap-4 px-4 py-3 text-sm font-medium"
        :class="
            sessionExpired
                ? 'bg-red-600 text-white'
                : 'bg-green-600 text-white'
        "
        role="alert"
        aria-live="assertive"
    >
        <span>
            {{
                sessionExpired
                    ? "Your session has expired — changes aren't being saved."
                    : "You're signed back in — save your work now."
            }}
        </span>

        <div class="flex items-center gap-2">
            <button
                v-if="sessionExpired"
                type="button"
                class="rounded bg-white/20 px-3 py-1 font-semibold transition hover:bg-white/30"
                @click="emit('sign-in')"
            >
                Sign in again
            </button>
            <button
                type="button"
                class="rounded bg-white px-3 py-1 font-semibold text-gray-900 transition hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-60"
                :disabled="isRetrying"
                @click="emit('retry')"
            >
                Save again
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import useEditorSession from '@composables/useEditorSession';

const emit = defineEmits<{
    (e: 'sign-in'): void;
    (e: 'retry'): void;
}>();

const { sessionExpired, isRetrying, bannerVisible } = useEditorSession();
</script>
